var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-195 -194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8609",
    "data-name": "Rectangle 8609",
    width: 18,
    height: 18,
    transform: "translate(195 194)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_136",
    "data-name": "Union 136",
    d: "M19166.51,7058.433a1.511,1.511,0,0,1-1.512-1.506v-6.492a1.514,1.514,0,0,1,1.512-1.511h2.475a.585.585,0,1,1,0,1.169h-2.475a.343.343,0,0,0-.342.341v6.492a.343.343,0,0,0,.342.342H19173a.343.343,0,0,0,.342-.342v-2.479a.582.582,0,0,1,1.164,0v2.479a1.508,1.508,0,0,1-1.506,1.506Zm1.854-2.777a.585.585,0,0,1-.582-.587v-1.853a.6.6,0,0,1,.168-.414l4.639-4.635a.586.586,0,0,1,.822,0l1.859,1.853a.593.593,0,0,1,0,.828l-4.641,4.634a.564.564,0,0,1-.408.173Z",
    transform: "translate(-18966 -6850.686)",
    fill: "#1b1c1d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9b2012fe5f21f97d99332e99c72df689.svg";
export { ForwardRef as ReactComponent };